<template>
  <div>
    <div class="container px-4 mx-auto mb-2 max-w-7xl sm:px-6 lg:px-8" id="top">
      <Breadcrumb />
    </div>
    <main>
      <div class="py-2 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div class="px-4 sm:px-0">
          <div class="bg-white rounded-md shadow">
            <div class="px-4 py-6 sm:p-10 vld-parent">
              <h1 class="text-2xl leading-7 text-center sm:text-3xl sm:leading-9 branch-name sm:text-left" v-if="branch && branch.name">
                {{ branch.name }} Post Office
              </h1>
              <div class="feedback-section">
                <a class="text-right cursor-pointer text-polred" target="_blank" :href="`${baseDomain}/feedback`">
                  Leave Feedback
                </a>
              </div>
              <loading :active.sync="isLoading" :opacity="1" :can-cancel="false" color="#58595b" :is-full-page="false"></loading>
              <template v-if="!isLoading">
                <BranchDetails :branch="branch" />
                <BranchQuestions :sections="branch.sections" v-if="branch.sections && !branch.pendingUpdates" />
                <template v-if="branch.pendingUpdates">
                <div class="p-4 mt-8 border-b-4 rounded-md border-polyellow-dark bg-polyellow">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <svg class="w-5 h-5" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="26" height="26">
                        <path d="M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                      </svg>
                    </div>
                    <div class="ml-3">
                      <p class="font-bold leading-5"> {{ branch.pendingUpdates }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
                <div class="mt-10 text-right">
                  <a tabindex="0" class="text-right cursor-pointer text-polred" @keyup.enter="$scrollToTop" @click="$scrollToTop">Back to top</a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay"
import BranchDetails from "../components/BranchDetails"
import BranchQuestions from "../components/BranchQuestions"
import Breadcrumb from "../components/Breadcrumb"

export default {
  name: "BranchAccessibility",
  data: () => {
    return {
      branch: null,
      isLoading: true,
      errorOccurred: false,
      baseDomain: process.env.VUE_APP_POL_BASE_DOMAIN
    };
  },
  mounted() {
    if (!this.$route.params.fadCode) {
      return;
    }

    let self = this

    this.$http
      .get(process.env.VUE_APP_BRANCH_API, {
        headers: { "x-api-key": process.env.VUE_APP_BRANCH_API_KEY },
        params: { fadCode: this.$route.params.fadCode }
      }).then(result => {
        this.isLoading = false
        this.branch = result.data
      }).catch(function() {
        self.$router.push("/page-not-found")
      });
  },
  components: {
    Loading,
    Breadcrumb,
    BranchDetails,
    BranchQuestions
  }
};
</script>


<style>



</style>